import { ProfitFilterType } from "@components/profit-chart";

export type ProfitServerData = {
  date: string;
  sum: number;
};

const dayByTypeAssociation = {
  day: 24,
  week: 7,
  month: 31,
  year: 12,
};

const generateMockData = (daysCount: number): ProfitServerData[] => {
  const mockData: ProfitServerData[] = [];
  const startDate = new Date();

  const isHourly = daysCount === 24;
  const isYearly = daysCount === 12;

  for (let i = 0; i < daysCount; i++) {
    const date = new Date(startDate);

    if (isHourly) {
      date.setHours(date.getHours() - i);
      mockData.push({
        date: date.toISOString(),
        sum: Math.floor(Math.random() * 25000),
      });
    } else if (isYearly) {
      date.setDate(1);
      date.setMonth(date.getMonth() + 1 - i);
      mockData.push({
        date: date.toISOString(),
        sum: Math.floor(Math.random() * 25000),
      });
    } else {
      date.setDate(date.getDate() - i);
      mockData.push({
        date: date.toISOString(),
        sum: Math.floor(Math.random() * 80000),
      });
    }
  }

  return mockData.reverse();
};

export const getProfit = async (type: ProfitFilterType) => {
  const daysCount = dayByTypeAssociation[type];
  // const response = await axiosInstance.get<ProfitServerData[]>(
  //   `/api/v1/main/historyIncome?userId=1&count=${daysCount}&page=1`
  // );

  // return response.data;

  return generateMockData(daysCount);
};
